import { defineModule } from "@kubdee/sdk";
import { MODULES } from "@kubdee/shared";
import { migrations } from "./migrations";
import { dormitoryDoctypes } from "./doctypes";

const MODULE_ICON = "Building2";
const MODULE_COLOR = "#0F766E";

export default defineModule({
  name: MODULES.DORMITORY,
  displayName: "Dormitory",
  label: "จัดการหอพัก",
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: "0.1.0",
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: "operations",
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: "หอพัก",
    icon: MODULE_ICON,
    groups: [
      {
        label: "ภาพรวม",
        items: [
          { label: "แดชบอร์ด", icon: "LayoutDashboard", path: "/dormitory/dashboard", exact: true },
        ],
      },
      {
        label: "ข้อมูลหลัก",
        items: [
          { label: "อาคาร", icon: "Building2", path: "/dormitory/buildings" },
          { label: "ห้องพัก", icon: "DoorOpen", path: "/dormitory/rooms" },
          { label: "ผู้เช่า", icon: "UsersRound", path: "/dormitory/tenants" },
          { label: "สัญญาเช่า", icon: "FileSignature", path: "/dormitory/leases" },
        ],
      },
      {
        label: "รอบบิล",
        items: [
          { label: "จดมิเตอร์", icon: "Gauge", path: "/dormitory/meter-readings" },
          { label: "รอบบิล", icon: "CalendarClock", path: "/dormitory/billing-periods" },
          { label: "บิลค่าเช่า", icon: "ReceiptText", path: "/dormitory/bills" },
        ],
      },
      {
        label: "รายงาน",
        items: [
          { label: "สรุปรายได้", icon: "BarChart3", path: "/dormitory/reports/revenue" },
        ],
      },
      {
        label: "ตั้งค่า",
        items: [
          { label: "ตั้งค่าหอพัก", icon: "Settings", path: "/dormitory/settings" },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "building", label: "อาคารหอพัก" },
    { key: "room", label: "ห้องพัก" },
    { key: "tenant", label: "ผู้เช่า" },
    { key: "lease", label: "สัญญาเช่า", type: "submittable" },
    { key: "billing_period", label: "รอบบิล" },
    { key: "meter_reading", label: "บันทึกมิเตอร์" },
    { key: "bill", label: "บิลค่าเช่า", type: "submittable" },
    { key: "settings", label: "ตั้งค่า" },
  ],
  availableHooks: [
    { event: "dormitory.lease.activated", label: "เริ่มสัญญาเช่า" },
    { event: "dormitory.meterReading.confirmed", label: "ยืนยันการจดมิเตอร์" },
    { event: "dormitory.billingPeriod.calculated", label: "คำนวณรอบบิล" },
    { event: "dormitory.bill.issued", label: "ออกบิลค่าเช่า" },
    { event: "dormitory.bill.paid", label: "รับชำระบิล" },
  ],
  customForms: [
    { key: "dormitory.calculate-billing-period", label: "คำนวณรอบบิลหอพัก" },
    { key: "dormitory.issue-bill", label: "ออกบิลค่าเช่า" },
    { key: "dormitory.mark-bill-paid", label: "รับชำระบิลค่าเช่า" },
  ],

  fixtures: [],
  moduleMigrations: migrations,
  registeredDoctypes: dormitoryDoctypes,
});
